(function () {
	/* Toggle content */
	$('.product-description-more').click(function (e) {
		e.preventDefault();
		$(this).closest('.product-description-short').next().show();
		$(this).closest('.product-description-short').hide();
	});

	$('.product-description-less').click(function (e) {
		e.preventDefault();
		$(this).closest('.product-description-full').prev().show();
		$(this).closest('.product-description-full').hide();
	});

	/* Toggle fields */
	$('.js-show-more').click(function (e) {
		e.preventDefault();
		$(this).siblings('input').removeClass('hidden');
		$(this).siblings('label').removeClass('hidden');
		$(this).remove();
	});
})();

/* Second floated product form */
class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute('data-product-url'))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
				this.productElement = responseHTML.querySelector('div[id^="ProductInfo-"]');

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll('script').forEach(oldScriptTag => {
			const newScriptTag = document.createElement('script');
			Array.from(oldScriptTag.attributes).forEach(attribute => {
				newScriptTag.setAttribute(attribute.name, attribute.value)
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `floated-${ sectionId }`);

		if (this.productElement.querySelectorAll('variant-selects')) {
			this.productElement.querySelectorAll('variant-selects').forEach(radio => {
				radio.dataset.originalSection = sectionId;
			});
		}

		if (this.productElement.querySelectorAll('variant-radios')) {
			this.productElement.querySelectorAll('variant-radios').forEach(radio => {
				radio.dataset.originalSection = sectionId;
			});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector('.product__text');
		if (text) text.remove();

		const shareButtons = this.productElement.querySelector('.share-buttons');
		if (shareButtons) shareButtons.remove();

		const rating = this.productElement.querySelector('.rating');
		if (rating) rating.remove();

		const tags = this.productElement.querySelector('.product-tags');
		if (tags) tags.remove();

		const description = this.productElement.querySelector('.product__description');
		if (description) description.remove();

		const advantage = this.productElement.querySelector('.advantage-wrapper');
		if (advantage) advantage.remove();

		const inventory = this.productElement.querySelector('.advantage');
		if (inventory) inventory.remove();

		const note = this.productElement.querySelector('.note');
		if (note) note.remove();

		const promoBanner = this.productElement.querySelector('.promo-banner');
		if (promoBanner) promoBanner.remove();

		const pickupAvailability = this.productElement.querySelector('pickup-availability');
		if (pickupAvailability) pickupAvailability.remove();

		const productModal = this.productElement.querySelector('product-modal');
		if (productModal) productModal.remove();

		const productForm = this.productElement.querySelector('floated-form');
		if (productForm) productForm.remove();

		const relatedProduct = this.productElement.querySelector('related-product');
		if (relatedProduct) relatedProduct.remove();

		const gift = this.productElement.querySelector('.customer');
		if (gift) gift.remove();

		const customLiquid = this.productElement.querySelector('.custom-liquid');
		if (customLiquid) customLiquid.remove();
	}

	showMoreFields() {
		$('.js-show-more').click(function (e) {
			e.preventDefault();
			$(this).siblings('input').removeClass('hidden');
			$(this).siblings('label').removeClass('hidden');
			$(this).remove();
		});
	}
}

customElements.define('floated-form', FloatedForm);

/* ============================================
   3-COLUMN LAYOUT: Fix thumbnail display for horizontal layout
   Keep Swiper working but restyle thumbnails horizontally
   ============================================ */
(function() {
	var initialized = false;

	function fix3ColThumbnails() {
		try {
			var product3col = document.querySelector('.product--3col');
			if (!product3col) return;
			if (initialized) return;

			var mainSlider = product3col.querySelector('.product__main .product__media-list.js-media-list');
			var sublist = product3col.querySelector('.product__main .product__media-sublist.js-media-sublist');

			if (!mainSlider || !sublist) return;

			// Wait for Swiper to be initialized on the main slider
			if (!mainSlider.swiper) {
				return; // Will retry on next timeout
			}

			initialized = true;
			var mainSwiper = mainSlider.swiper;

			// Fix: Set spaceBetween to 0 to prevent slide preview bleeding
			if (mainSwiper.params) {
				mainSwiper.params.spaceBetween = 0;
				mainSwiper.update();
			}

			// Get thumbnail slides
			var thumbSlides = sublist.querySelectorAll('.swiper-slide');
			if (thumbSlides.length === 0) return;

			// Add click handlers to thumbnails to control main swiper
			thumbSlides.forEach(function(thumb, index) {
				thumb.style.cursor = 'pointer';

				// Remove any existing click listeners by cloning
				var newThumb = thumb.cloneNode(true);
				thumb.parentNode.replaceChild(newThumb, thumb);

				newThumb.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();

					// Navigate main swiper to this slide
					if (mainSwiper && typeof mainSwiper.slideTo === 'function') {
						mainSwiper.slideTo(index);
					}

					// Update active state on thumbnails
					var allThumbs = sublist.querySelectorAll('.swiper-slide');
					allThumbs.forEach(function(t, i) {
						if (i === index) {
							t.classList.add('swiper-slide-thumb-active');
							t.style.borderColor = 'var(--color-base-accent-1, #8B2332)';
						} else {
							t.classList.remove('swiper-slide-thumb-active');
							t.style.borderColor = 'rgba(0,0,0,0.1)';
						}
					});
				});
			});

			// Listen for main swiper slide changes to update thumbnail active state
			if (mainSwiper.on) {
				mainSwiper.on('slideChange', function() {
					var activeIndex = mainSwiper.activeIndex;
					var allThumbs = sublist.querySelectorAll('.swiper-slide');
					allThumbs.forEach(function(t, i) {
						if (i === activeIndex) {
							t.classList.add('swiper-slide-thumb-active');
							t.style.borderColor = 'var(--color-base-accent-1, #8B2332)';
						} else {
							t.classList.remove('swiper-slide-thumb-active');
							t.style.borderColor = 'rgba(0,0,0,0.1)';
						}
					});

					// Scroll thumbnail into view if needed
					var activeThumb = allThumbs[activeIndex];
					if (activeThumb && activeThumb.scrollIntoView) {
						activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
					}
				});
			}

			// Set initial active state
			var initialThumbs = sublist.querySelectorAll('.swiper-slide');
			if (initialThumbs.length > 0) {
				initialThumbs[0].classList.add('swiper-slide-thumb-active');
				initialThumbs[0].style.borderColor = 'var(--color-base-accent-1, #8B2332)';
			}

			console.log('3col thumbnails fixed - click handlers added');
		} catch (e) {
			console.log('3col thumbnail fix error:', e);
		}
	}

	// Run after Swiper has initialized - retry multiple times
	setTimeout(fix3ColThumbnails, 500);
	setTimeout(fix3ColThumbnails, 1000);
	setTimeout(fix3ColThumbnails, 2000);
	setTimeout(fix3ColThumbnails, 3000);
})();
